'use strict';

var _ = require('lodash');
var JQXTreeNodeGroupFactory = function JQXTreeNodeGroupFactory(Node) {
  function GroupNode(params) {
    Node.call(this, params);
    this.items = params.items;
    this.expanded = params.dataDrivenColumn ? false : params.expanded;
    this.dataDrivenColumn = params.dataDrivenColumn;
    if (_.isUndefined(params.checked) === true) {
      this.checked = this.getCheckedState(params.items);
    }
  }
  GroupNode.prototype = Object.create(Node.prototype);
  GroupNode.prototype.constructor = GroupNode;
  GroupNode.prototype.getCheckedState = function (items) {
    var someChecked = _.some(items, {
      checked: true
    });
    var someUnchecked = _.some(items, {
      checked: false
    });

    // It means items is either empty, or there are both checked & unchecked items.
    // Return indeterminate state
    if (someChecked === someUnchecked) {
      return undefined;
    }

    // Otherwise it means either all items are checked or not.
    return someChecked;
  };
  return GroupNode;
};
JQXTreeNodeGroupFactory.$inject = ['JQXTreeNodeFactory'];
module.exports = JQXTreeNodeGroupFactory;